import { render, staticRenderFns } from "./sidebar_profile.vue?vue&type=template&id=1c333d16&"
import script from "./sidebar_profile.vue?vue&type=script&lang=js&"
export * from "./sidebar_profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports